// import CTA from 'react-scale/components/elements/cta';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import cn from 'classnames';
import Balancer from 'react-wrap-balancer';

import Image from 'next/image';
import Video from 'react-scale/components/elements/video';

// import MeshGradient from 'react-scale/components/elements/webgl/mesh-gradient';
import styles from './hero.module.css';

const CustomersHero = ({ logo, text, image, video, info }) => (
  // const cleanWebgl = typeof webgl === 'boolean' ? webgl.style : webgl;

  <div className="bg-neutral-100">
    {/* <div className="absolute inset-0 z-0 bg-black pointer-events-none">
        <MeshGradient style={cleanWebgl} />
        <div className="absolute inset-0 w-full bg-gradient-to-b from-black" />
      </div> */}
    <div className="container py-12 md:mb-20 md:py-20">
      <div className="md:flex">
        <div className="basis-1/3">
          {logo && (
            <div className="w-2/3 pt-4">
              <img className="md:w-56" src={logo.image} alt={logo.alt} />
            </div>
          )}
        </div>

        <div className="basis-2/3">
          {text && (
            <h2 className="mt-8 mb-8 text-3xl text-black md:mt-0 md:mb-18 font-aeonik md:text-6xl">
              <Balancer>{text}</Balancer>
            </h2>
          )}
          {/* {cta && (
            <div className="mt-10">
              <CTA cta={cta} theme="light" />
            </div>
          )} */}
        </div>
      </div>
      <div className="mt-10 md:flex md:mt-0">
        <div className="md:basis-1/3">
          {info && (
            <div className="hidden pl-6 border-l border-scale-lightmauve lg:block">
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                className={cn(styles.info, 'text-base leading-9 text-neutral-600')}
              >
                {info}
              </ReactMarkdown>
            </div>
          )}
        </div>
        <div className="basis-2/3 md:max-h-[18em]">
          <div>
            {video?.url && <Video url={video.url} poster={video.poster} />}
            {!video?.url && image && (
              <div className="relative overflow-hidden shadow-lg aspect-video rounded-2xl">
                <Image src={image} layout="fill" objectFit="cover" alt={image?.alt} unoptimized />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);
export default CustomersHero;
